import { useEffect, useRef, useState } from "react"
import ProgressBar from "../../Components/ProgressBar"
import AddressInputNew from "../../Components/WizzardSteps/AddressInputNew";
import ContactInfo from "../../Components/WizzardSteps/ContactInfo";
import { useWizard } from "../../Contexts/WizardContext";
import { ServiceSelection } from "../../Components/WizzardSteps/ServiceSelection";
import { CalendarView } from "../../Components/WizzardSteps/CalendarView";
import PaymentMethod from "../../Components/WizzardSteps/PaymentMethod";
import ThankYou from "../../Components/ThankYouPage";

const wizardSteps = [
    { id: 1, component: AddressInputNew },
    { id: 2, component: ContactInfo },
    { id: 3, component: ServiceSelection },
    { id: 4, component: CalendarView },
    { id: 5, component: PaymentMethod },
    { id: 6, component: ThankYou },
  ];

  const progressSteps = [
    { id: 1, label: 'Service Location' },
    { id: 2, label: 'Contact Info' },
    { id: 3, label: 'Choose Service' },
    { id: 4, label: 'Schedule' },
    { id: 5, label: 'Confirmation' },
    { id: 6, label: 'Thank You' },
  ];

export default function HomePage() {
    const {currentStep, formData} = useWizard()

    const topRef = useRef(null);

    useEffect(() => {
      topRef.current?.scrollIntoView({ top: 0, behavior: 'smooth' });
    }, [currentStep]);
    

    useEffect(() => {
        if (currentStep == 5) {
            console.log('forma data after step 4', formData)
        }
    }, [currentStep])

    const CurrentStepComponent = wizardSteps[currentStep - 1].component;
    
    return (
        <main ref={topRef} className="flex-1 flex flex-col justify-center py-8 px-4">
            <div className="max-w-4xl w-full mx-auto">
                <div className="bg-white rounded-2xl shadow-xl overflow-y-auto">
                    <ProgressBar
                        currentStep={currentStep}
                        totalSteps={progressSteps.length}
                        steps={progressSteps}
                    />
                    <div className="p-6 sm:p-8">
                        <CurrentStepComponent />
                    </div>
                </div>
            </div>
        </main>
    )
}